import { render } from "./Products.vue?vue&type=template&id=21b0bba3&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=21b0bba3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21b0bba3"

export default script